export const DISCOVERY_PATH_PREFIX = '/event-discovery';

export const withDiscoveryPath = path => `${DISCOVERY_PATH_PREFIX}${path}`;
